import { Component, Element, Host, h, Prop, Watch } from '@stencil/core';
import { getAssetSrc, getTenant } from '../../helpers/helpers';
import type { Product } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-product-highlight',
  styleUrl: 'cms-product-highlight.scss',
  shadow: true,
})
export class CmsProductHighlight {
  private readonly backgroundImage = 'Estrich_hell.jpg';
  private readonly backgroundScratch = 'product-highlight-scratch-white.svg';
  private article: Product;

  @Element() element: HTMLElement;

  /**
   * set the component headline
   */
  @Prop() headline = '';

  /**
   * Set the alt-text for the article-image
   */
  @Prop() articleImageAlt: string;

  /**
   * Set the article to be displayed
   */
  @Prop() product!: Product | string;

  /**
   * Set the label for the CTA
   */
  @Prop() ctaLabel = '';
  /**
   * Set the title which is used in the ratings
   */
  @Prop() ratingTitle = '';
  /**
   * set accessible-name for the energy-label datasheet-link
   */
  @Prop() datasheetAccessibleName?: string;

  @Watch('product')
  private articleWatcher(newValue: Product | string) {
    if (newValue) {
      this.article =
        typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
    }
  }

  /*
    Lifecycle
  */
  connectedCallback() {
    if (this.product) {
      this.articleWatcher(this.product);
    }
  }

  render() {
    const containerStyle = {
      backgroundImage: `url(${getAssetSrc(this.backgroundImage)})`,
    };

    const wrapperStyle = {
      '--cms-product-highlight-scratch': `url('${getAssetSrc(this.backgroundScratch)}')`,
      background: 'var(--cms-product-highlight-scratch) 0 0 no-repeat',
    };

    return (
      <Host>
        <div class='section-inner'>
          <div style={containerStyle} class='container'>
            <div
              class='wrapper'
              style={
                getTenant() === 'hornbach'
                  ? wrapperStyle
                  : {
                      background:
                        'var(--cms-semanticColors-container-weak-background)',
                    }
              }
            >
              <div class='title-wrapper'>
                <cms-badge
                  name={this.headline}
                  theme='service'
                  size='badge-sm'
                />
              </div>
              <cms-product-card
                style={{
                  '--cms-article-image-ratio': '5/4',
                }}
                article={this.article}
                ctaLabel={this.ctaLabel}
                layout='horizontal'
                ctaStyle='button'
                ratingTitle={this.ratingTitle}
                datasheetAccessibleName={this.datasheetAccessibleName}
              />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
